document.addEventListener('DOMContentLoaded', () => {
  console.log('[Collection Form] Script loaded and initialized');
  const netlifyFunctionUrl = 'https://orvizoho.netlify.app/.netlify/functions/collection-form';
  let formInitialized = false;
  let initializedForms = new Set();

  const collectionLeadSources = {
    '/pages/spring-collection': 'springIR',
    '/pages/arai-collection': 'araiIR',
    '/pages/new-collection': 'newIR',
    '/pages/arazzi-collection': 'arazziIR',
    '/pages/florim-collection': 'florimIR',
    '/pages/tesserae-collection': 'tesseraeIR',
    '/pages/tarkashi-collection': 'tarkashiIR',
    '/pages/palacio-collection': 'palacioIR',
    '/pages/lines-collection': 'linesIR',
    '/pages/thikri-art-collection': 'thikri-artIR',
    '/pages/lippan-collection': 'lippanIR',
    '/pages/enigma-collection': 'enigmaIR',
    '/pages/filo-collection': 'filoIR',
    '/pages/brise-collection': 'briseIR',
    '/pages/raku-collection': 'rakuIR',
    '/pages/bauhaus-collection': 'bauhausIR',
    '/pages/haute-couture-collection': 'haute-coutureIR',
    '/pages/blazon-collection': 'blazonIR',
    '/pages/armatura-collection': 'armaturaIR',
    '/pages/flora-collection': 'floraIR',
    '/pages/skin-collection': 'skinIR',
    '/pages/molecules-collection': 'moleculesIR',
    '/pages/supernova-collection': 'supernovaIR',
    '/pages/fessura-collection': 'fessuraIR',
    '/pages/tressage-collection': 'tressageIR',
    '/pages/filigree-collection': 'filigreeIR',
    '/pages/sahara-collection': 'saharaIR',
    '/pages/moment-collection': 'momentIR',
    '/pages/kirigami-collection': 'kirigamiIR',
    '/pages/flow-collection': 'flowIR',
    '/pages/elementa-collection': 'elementaIR',
    '/pages/glyph-collection': 'glyphIR',
    '/pages/trenza-collection': 'trenzaIR',
    '/pages/nuages-collection': 'nuagesIR',
    '/pages/veins-collection': 'veinsIR',
    '/pages/solid-stone': 'solidIR'
  };

  const currentPath = window.location.pathname;
  // Check if we are on a valid collection page
  if (!collectionLeadSources[currentPath]) {
    console.log('[Collection Form] Not a target collection page, exiting.');
    return;
  }

  const getLeadSource = () => {
    // All collection forms use 'Product Enquiry' as the lead source
    return 'Product Enquiry';
  };

  const getSourceByGroup = () => {
    // Get the current page path for tracking which collection form was used
    const currentPath = window.location.pathname;
    // Return the specific collection name if found, otherwise default to 'Product Enquiry'
    return collectionLeadSources[currentPath] || 'Product Enquiry';
  };

  const waitForElement = (selector, timeout = 10000) => {
    return new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }

      const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
          obs.disconnect();
          resolve(element);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
      }, timeout);
    });
  };

  const setupInfoRequestLinks = () => {
    const infoRequestSelectors = [
      'a.info-req',
      '.info-req a',
      'a:contains("INFORMATION REQUEST")'
    ];

    let foundLinks = [];
    infoRequestSelectors.forEach(selector => {
      try {
        const links = document.querySelectorAll(selector);
        links.forEach(link => {
          if (!foundLinks.includes(link)) {
            foundLinks.push(link);
          }
        });
      } catch (e) {
        // Invalid selector
      }
    });

    foundLinks.forEach(link => {
      link.removeEventListener('click', infoRequestClickHandler);
      link.addEventListener('click', infoRequestClickHandler);
    });
  };

  const infoRequestClickHandler = () => {
    formInitialized = false;
    setTimeout(() => initInfoRequestFormInPopup(), 500);
    setTimeout(() => { if (!formInitialized) initInfoRequestFormInPopup(); }, 1500);
    setTimeout(() => { if (!formInitialized) initInfoRequestFormInPopup(); }, 3000);
  };

  const initInfoRequestFormInPopup = async () => {
    console.log('[Collection Form] Initializing info request form...');

    try {
      const formSelectors = [
        '#info_form',
        'form[action="/contact#info_form"]',
        '.contact-form form'
      ];

      let infoRequestForm = null;
      for (const selector of formSelectors) {
        try {
          console.log('[Collection Form] Trying selector:', selector);
          infoRequestForm = await waitForElement(selector, 3000);
          if (infoRequestForm) {
            console.log('[Collection Form] Found form with selector:', selector);
            break;
          }
        } catch (e) {
          console.log('[Collection Form] Selector failed:', selector);
        }
      }

      if (!infoRequestForm) {
        console.log('[Collection Form] No form found');
        return;
      }

      const formId = infoRequestForm.id || infoRequestForm.action || 'form-' + Date.now();
      console.log('[Collection Form] Form ID:', formId);

      // Check if this form is already handled
      if (infoRequestForm.hasAttribute('data-orvi-handled')) {
        console.log('[Collection Form] Form already handled, skipping');
        return;
      }

      // Inject City field for Information Request form
      const companyInput = infoRequestForm.querySelector('input[name="contact[Company]"]');
      const cityInputExists = infoRequestForm.querySelector('input[name="contact[City]"]');

      if (companyInput && !cityInputExists) {
        const cityWrapper = document.createElement('div');
        const inputClass = companyInput.className;
        const parentClass = companyInput.parentElement.className;

        cityWrapper.className = parentClass || 'form-group';
        cityWrapper.innerHTML = `<input type="text" name="contact[City]" class="${inputClass}" placeholder="City" required>`;

        const companyContainer = companyInput.closest('div') || companyInput;
        companyContainer.after(cityWrapper);
      }

      const fieldMappings = findInfoRequestFormFields(infoRequestForm);
      console.log('[Collection Form] Field mappings:', Object.keys(fieldMappings).reduce((acc, key) => {
        acc[key] = fieldMappings[key] ? 'found' : 'missing';
        return acc;
      }, {}));

      // Only check truly required fields (city is required, company and message are optional)
      const missingFields = ['firstName', 'lastName', 'email', 'phone', 'city'].filter(f => !fieldMappings[f]);
      if (missingFields.length > 0) {
        console.error('[Collection Form] Missing required fields:', missingFields);
        console.log('[Collection Form] Form structure:', infoRequestForm.innerHTML.substring(0, 500));
        initializedForms.add(formId);
        return;
      }

      const boundHandler = (e) => handleInfoRequestFormSubmit(e, fieldMappings);

      // Add event listener directly
      infoRequestForm.addEventListener('submit', boundHandler);
      console.log('[Collection Form] Event listener added to form');

      // Mark form as handled to prevent conflicts
      infoRequestForm.setAttribute('data-orvi-handled', 'collection-form-script');
      initializedForms.add(formId);
      formInitialized = true;
      console.log('[Collection Form] Form initialized successfully!');

    } catch (error) {
      console.error('[Collection Form] Initialization error:', error);
    }
  };

  const findInfoRequestFormFields = (form) => {
    return {
      firstName: form.querySelector('input[name="contact[first_name]"]') || form.querySelector('input[placeholder="First Name"]'),
      lastName: form.querySelector('input[name="contact[last_name]"]') || form.querySelector('input[placeholder="Last Name"]'),
      email: form.querySelector('input[name="contact[email]"]'),
      phone: form.querySelector('input[name="contact[phone]"]'),
      company: form.querySelector('input[name="contact[Company]"]') || form.querySelector('input[name="contact[company]"]'),
      city: form.querySelector('input[name="contact[city]"]') || form.querySelector('input[name="contact[City]"]'),
      message: form.querySelector('textarea[name="contact[Message]"]') || form.querySelector('textarea[name="contact[message]"]')
    };
  };

  const init = () => {
    setupInfoRequestLinks();
    initInfoRequestFormInPopup();
  };

  const handleInfoRequestFormSubmit = async (event, fieldMappings) => {
    console.log('[Collection Form] Form submitted!');
    event.preventDefault();

    const form = event.target;
    const submitButton = form.querySelector('button[type="submit"]');
    const originalButtonText = submitButton ? submitButton.innerHTML : '';

    const leadSource = getLeadSource();
    console.log('[Collection Form] Lead source:', leadSource);
    if (!leadSource) {
      console.error('[Collection Form] No lead source found');
      return;
    }

    let formData;
    try {
      formData = {
        name: `${(fieldMappings.firstName?.value || '').trim()} ${(fieldMappings.lastName?.value || '').trim()}`.trim(),
        email: (fieldMappings.email?.value || '').trim(),
        phone: (fieldMappings.phone?.value || '').trim(),
        company: (fieldMappings.company?.value || '').trim(),
        city: (fieldMappings.city?.value || '').trim(),
        description: (fieldMappings.message?.value || '').trim(),
        leadSource: 'Product Enquiry',
        sourceByGroup: getSourceByGroup()
      };
    } catch (error) {
      return;
    }

    // Mandatory: All except Description (Message) and Company
    // Company is optional as some forms may not have it
    const missingRequiredFields = ['name', 'email', 'phone', 'city'].filter(key => !formData[key]);
    if (missingRequiredFields.length > 0) {
      console.error('Missing required fields:', missingRequiredFields);
      alert(`Please fill in the following required fields: ${missingRequiredFields.map(f => f.charAt(0).toUpperCase() + f.slice(1)).join(', ')}`);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerHTML = 'Sending...';
    }

    console.log('[Collection Form] Submitting with data:', formData);
    console.log('[Collection Form] Netlify function URL:', netlifyFunctionUrl);

    try {
      const response = await fetch(netlifyFunctionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData),
      });

      console.log('[Collection Form] Response status:', response.status, response.statusText);

      let result;
      try {
        result = await response.json();
        console.log('[Collection Form] Response data:', result);
      } catch (parseError) {
        console.error('[Collection Form] Failed to parse response:', parseError);
        throw new Error('Invalid response from server');
      }

      if (response.ok && result.success) {
        console.log('Collection form submitted successfully:', result);
        if (submitButton) submitButton.innerHTML = 'Sent!';
        alert('Thank you! Your information request has been submitted successfully.');
        form.reset();

        setTimeout(() => {
          if (submitButton) {
            submitButton.innerHTML = originalButtonText;
            submitButton.disabled = false;
          }
        }, 3000);

      } else {
        console.error('Collection form submission failed:', result);
        alert(result.error || 'There was an error submitting your request. Please try again.');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerHTML = originalButtonText;
        }
      }
    } catch (error) {
      console.error('Collection form submission error:', error);
      alert('Network error. Please check your connection and try again.');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerHTML = originalButtonText;
      }
    }
  };

  init();
  setTimeout(() => { if (!formInitialized) init(); }, 2000);

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const hasForm = document.querySelector('form[action="/contact#info_form"]') || document.querySelector('.contact-form form');
        if (hasForm) {
          setTimeout(() => initInfoRequestFormInPopup(), 100);
        }
        setupInfoRequestLinks();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  ['load', 'shopify:section:load', 'show.bs.modal', 'modalopen', 'popup:open'].forEach(eventName => {
    document.addEventListener(eventName, () => {
      setTimeout(() => initInfoRequestFormInPopup(), 300);
    });
  });
});